import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseConhecimentoListarComponent } from './base-conhecimento-listar/base-conhecimento-listar.component';
import { BaseConhecimentoDetalharComponent } from './base-conhecimento-detalhar/base-conhecimento-detalhar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: BaseConhecimentoListarComponent},
    {path: ':id', data: {breadcrumb: 'Detalhar'}, component: BaseConhecimentoDetalharComponent}
  ])],
  exports: [RouterModule]
})
export class BaseConhecimentoRoutingModule { }
